import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTIONS_VERIFY_OTP } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import axios from "axios";
import { toast } from "../../components/app-toast";
import { getLocalizedErrorMessage } from "../../utils/messageHelper";
import i18n from "../../i18n";

export const resendOtp = createAsyncThunk(
  ACTIONS_VERIFY_OTP.resend_otp, // Add this in your action-types
  async (payload) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + APP_PATH.resendOtp,
        payload,
      );

      console.log("Resend OTP Response:", response);
      return response;
    } catch (error) {
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message || i18n.t("toast.somethingWentWrong"));
      console.log("Resend OTP Error:", error?.response?.data?.message);
      throw error;
    }
  },
);
